import { Chip } from '@ovComponents/2-component/chip/chip';
import type { Theme } from 'hephaestus/core';
import { Box, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { SECONDARY_TEXT_SX } from '../styles';
import type { PortfolioReport } from '../types';
import { getPortfolioName } from '../utils';
export type PortfolioRowDetailHeaderProps = {
  report: PortfolioReport;
  theme: Theme;
};

export const PortfolioRowDetailHeader = ({
  report,
  theme,
}: PortfolioRowDetailHeaderProps) => {
  const { t } = useTranslation('portfolioTradingHub');

  const goalObject = report.object as { type?: string };
  const subAccountObject = report.object as {
    account?: { type?: string; taxRank?: number };
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 1.5,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography variant='titleMedium' sx={{ fontWeight: 600 }}>
          {getPortfolioName(report)}
        </Typography>
        <Typography variant='labelSmall' sx={SECONDARY_TEXT_SX}>
          {report.modelPortfolio?.translatedName?.en ||
            t('rowDetail.header.noModel')}
          {report.modelPortfolioType === 'GOAL' && goalObject.type
            ? t('rowDetail.header.goalTypeSuffix', { type: goalObject.type })
            : ''}
          {report.modelPortfolioType === 'SUB_ACCOUNT' &&
          subAccountObject.account?.type
            ? t('rowDetail.header.subAccountTypeSuffix', {
                accountType: subAccountObject.account.type,
                taxRank: subAccountObject.account.taxRank,
              })
            : ''}
        </Typography>
        {report.originalCurrencies && report.originalCurrencies.length > 1 && (
          <Chip
            text={t('rowDetail.header.multiCcy', {
              currencies: report.originalCurrencies.join(', '),
            })}
            small
          />
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          variant='bodySmall'
          sx={{ color: theme.color.onSurfaceVariant }}
        >
          {t('rowDetail.header.updatedAt', {
            date: new Date(report.updatedAt).toLocaleString(),
          })}
        </Typography>
      </Box>
    </Box>
  );
};
